import SuccessPageWrapper from './SuccessPageWrapper'

const ResetPasswordSuccessPage = () => (
  <SuccessPageWrapper>
    You’ve successfully reset your password
  </SuccessPageWrapper>
)

export default ResetPasswordSuccessPage
